<section class="max-w-lg mx-auto bg-white shadow-xl rounded-xl overflow-hidden border border-gray-300">

	<!-- Header -->
	<header class="bg-gradient-to-r from-gray-900 to-gray-800 text-gray-100 text-center py-8 px-6">
		<h1 class="text-4xl font-bold leading-tight drop-shadow-md">
			&#161;Hola <span class="text-blue-400">{{ nombrePersona }}</span>!
		</h1>        
		<p class="text-gray-300 text-lg mt-2 font-light">
			Hemos recibido tu mensaje.
		</p>
	</header>

	<!-- Image -->
	<div class="text-center bg-gray-100 p-6">
		<img src="assets/img/emailpicture.png" alt="Confirmaci&oacute;n de contacto" class="mx-auto rounded-lg shadow-lg w-full max-w-md">
	</div>

	<!-- Main Content -->
	<main class="p-6 text-gray-700">
		<p class="text-lg leading-relaxed text-gray-800">
			Gracias por contactarnos. Nuestro equipo revisar&aacute; tu mensaje y se pondr&aacute; en contacto contigo a la brevedad.
		</p>

		<p class="mt-4 text-gray-600">
			Si necesitas soporte, no dudes en <strong>contactarnos</strong> al <strong>+56 9 6347 2977</strong>.
		</p>
	</main>

	<!-- Action Button -->
	<section class="text-center py-6">
		<a href="https://www.dev.arq-it.cl" class="inline-block px-6 py-2 border border-blue-600 text-blue-600 rounded-lg text-lg font-semibold transition-all duration-300 hover:bg-blue-600 hover:text-white">
			Vis&iacute;tanos
		</a>
	</section>

	<!-- Footer -->
	<footer class="bg-gray-900 text-gray-400 text-center py-5 text-sm">
		<p>&copy; 2024 <strong class="text-gray-200">{{ companyName }}</strong>. Todos los derechos reservados.</p>
		<div class="mt-2">
			<a href="/unsubscribe" class="text-blue-400 hover:text-blue-300 transition-all">
				Cancelar suscripci&oacute;n
			</a>
		</div>
	</footer>

</section>
